import type { ReactNode } from 'react';
import { JOURNEY_QUESTIONNAIRE_STEP_OFFSET } from '@/lib/journey-steps';
import JourneyProgressStepper from './JourneyProgressStepper';
import WizardStepper from './WizardStepper';
import wizardStyles from '@/styles/wizard.module.css';

export interface WizardShellProps {
  currentStep: number;
  children: ReactNode;
  footer?: ReactNode;
  /** Map shown as completed; questionnaire as steps 2–5; assessment last. */
  variant?: 'journey' | 'standalone';
}

export default function WizardShell({
  currentStep,
  children,
  footer,
  variant = 'standalone',
}: WizardShellProps) {
  return (
    <div className={wizardStyles.wizard} data-testid="wizard-shell">
      {variant === 'journey' ? (
        <JourneyProgressStepper
          activeIndex={currentStep + JOURNEY_QUESTIONNAIRE_STEP_OFFSET}
        />
      ) : (
        <WizardStepper currentStep={currentStep} variant="standalone" />
      )}
      <div className={wizardStyles.body}>
        {children}
        {footer}
      </div>
    </div>
  );
}
